import React from 'react'
import CareerDetails from '../CareerDetails'
import jobList from './positionList.json'

const FullStackDeveloper = () => {
  return <CareerDetails {...jobList[2]} />
}

export default FullStackDeveloper
